module.exports = __webpack_public_path__ + "img/img5.28382bc9.png";